import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES } from './../../common/helper/common-imports.component.js';
import DataTable from 'react-data-table-component';

import CryptoService from "../../../services/crypto-service.js";
import StatusBadge from '../../common/helper/transaction-status.component.js';
import { customDataTableStyles } from '../../common/helper/data-table.styles.js';
const CryptoListMerchant = () => { 
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const dispatch = useDispatch();

  const [crypto, setCrypto] = useState([]);
 
  const columnsMerchants = [
  
   
    {
      name: 'Order ID',
      selector: row =>  <div className="custom-cell-order_Code_crypto">{row.order_id}</div>,
      sortable: true,
      //style: row => ({ minWidth: '100px' }),
    },
    {
      name: 'Status',
      //selector: row => row.email_address,
      cell: row =>   <StatusBadge status={row.status} />,
      sortable: true,
     // style: row => ({ minWidth: '100px' }),
    },
    {
      name: 'Type',
      selector: row => <div className="custom-cell-request_type">{row.request_type == 'B' ? 'Buy':'Sell'}</div>,
      sortable: true,
      //style: row => ({ minWidth: '100px' }),
    },
   
    {
      name: 'Requested Quantity',
      //selector: row => row.email_address,
      cell: row => row.requested_quantity ? '₹' + row.requested_quantity:'₹0',
      sortable: true,
     // style: row => ({ minWidth: '100px' }),
    },
    {
      name: 'Approved Quantity',
      //selector: row => row.email_address,
      cell: row => row.approved_quantity ? '₹' + row.approved_quantity:'₹0',
      sortable: true,
     // style: row => ({ minWidth: '100px' }),
    },
    {
      name: 'Requested Rate',
      //selector: row => row.email_address,
      cell: row =>row.requested_rate ? '₹' + row.requested_rate:'₹0',
      sortable: true,
     // style: row => ({ minWidth: '100px' }),
    },
    {
      name: 'Approved Rate',
      //selector: row => row.email_address,
      cell: row => row.approved_rate ? '₹' + row.approved_rate:'₹0',
      sortable: true,
     // style: row => ({ minWidth: '100px' }),
    },
    {
      name: 'Created_on',
      //selector: row => row.email_address,
      cell: row => <div className="custom-cell-email_address">{row.created_on}</div>,
      sortable: true,
     // style: row => ({ minWidth: '100px' }),
    },
    {
      name: "Actions",
      button: true,
      style: row => ({ zIndex:0 }),
      cell: row =>
       <>

        <a className={`fview tooltip ${row.status === 'Rejected' ? 'disable' : ''}`} style={{'cursor':'pointer'}}  onClick={() => ViewCrypto(row.id)}>
         <i className={`fa ${ row.status === 'Rejected' ? 'fa-eye disable' : 'fa-eye'}`} style={{ color: row.user_id && !!expanded[row.user_id] ? 'white' : 'black' }}/>
          <span className="tooltiptext">View</span>
        </a>
         
         
         
          
          </>
   
    }
  ];



  const ViewCrypto = (id) => {
    navigate(`/view-crypto/${id}`);
  }


  const approveAgent = (row) => {
    if(row.is_verification_pending == true) {
      toast.error('Agent email verification is pending.')
      return
    }
    navigate(`/approve-agent/${row.user_id}`)
  }
  const getCryptoList = (e) => {
    setLoading(true);
    CryptoService.getCrypto()
      .then(response => {
        setCrypto(response.data.data.list)
   
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  useEffect(() => {
    getCryptoList('MERCHANT');
    document.body.style.backgroundImage = '';
    document.body.style.backgroundColor = '#f0f6fa';
    
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);
  const navigate = useNavigate();


  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setDataTableKey(prevKey => prevKey + 1);
  };

const paginationComponentOptions = { 
  noRowsPerPage :true
}
const handleSearchChange = (e) => {
  setSearchTerm(e.target.value);
};

const escapeRegExp = (string) => {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};
const filteredData = crypto.filter((row) =>
Object.values(row).some(
  (value) =>
    new RegExp(escapeRegExp(searchTerm), 'i').test(value)
)
  );


const resetSearch = (tab) => {
  setRowsPerPage(10);

  setSearchTerm('');
}
const buyCrypto = () => {
    navigate('/buy-sell')
}




  return (
    <div>
            <LoaderOverlay loading={loading} />

    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
                    <div className="container" style={{backgroundColor: 'white'}}>
                      <nav>
                        <div className="nav nav-tabs" id="nav-tab" role="tablist" >
                          <button className="nav-link active tbbtn" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" onClick={() => resetSearch('approved')}> Crypto List </button>
           
                        
                        </div>
                      </nav>
    
                      <div className="filterBtn">
                        
                        <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search" className placeholder="Search..."  value={searchTerm}
                        onChange={handleSearchChange} aria-controls="examplemgm" /></label></div>
                          <div className="dt-buttons ui-buttonset"><a className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg" tabIndex={0} aria-controls="examplemgm"><span className="ui-button-text" onClick={buyCrypto}>Buy/Sell Crypto</span></a></div>
                  </div>

                    <div className="dataTables_length" id="examplemgm_length">
                                    <label>Show &nbsp;</label>
                      <select value={rowsPerPage} name="examplemgm_length" onChange={handleRowsPerPageChange}>
                       
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      &nbsp;entries
                    </div>
                      <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
                        <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab" style={{position: 'relative'}}>

                        <div className="multi">
                          <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" /></div>

                        <DataTable key={dataTableKey}
                            columns={columnsMerchants}
                              data={filteredData}
                              pagination
                              
                              
                             
                              
                              paginationComponentOptions={paginationComponentOptions} 
                             
                              paginationPerPage={rowsPerPage} 
                             customStyles={customDataTableStyles}
                            
                              
                        />
                        </div>
                     
                      
                      </div>
                    </div>
                  </div>
                  
                  </div>
               

)

}
function mapStateToProps(state) {
   const userData = state.authReducer.user;
   return { userData };
 }
 export default withAuth(connect(mapStateToProps)(CryptoListMerchant));

 
 
